const getInputSelector = ( withTextArea = false ) => {
  const selectors = [
    'input[type="text"]',
    'input[type="email"]',
    'input[type="password"]',
    'input[type="date"]',
    'input[type="time"]',
    'input[type="url"]',
    'input[type="number"]',
    'input[type="tel"]',
  ];
  if ( withTextArea ) selectors.push( 'textarea' );
  let output = '';
  for ( const selector of selectors )
    output += selector + '.wpcf7-form-control,';
  return output.slice( 0, -1 );
};


const updateFields = ( fields ) => {
  fields.each( ( i, field ) => {
    field = $( field );
    const p = field.closest( 'p' );
    if ( field.val() === null || field.val() === '' ) {
      p.removeClass( 'focused' );
    } else {
      p.addClass( 'focused' );
    }
  } );
};

const validatePhoneNumberCharacter =( event )=> {
  const keycode = event.which;
  const allowed = [46, 8, 39, 40, 41, 43, 45];
  if (
    !(
      allowed.indexOf( keycode ) !== -1 ||
      ( keycode >= 48 && keycode <= 57 )
    )
  ) {
    event.preventDefault();
  }
};

const validateNameCharacter = ( event ) => {
  const keycode = event.which;
  if (
    ( keycode > 0 && keycode < 8 ) ||
    ( keycode > 8 && keycode < 32 ) ||
    ( keycode > 32 && keycode < 45 ) ||
    ( keycode > 45 && keycode < 65 ) ||
    ( keycode > 90 && keycode < 97 ) ||
    ( keycode > 122 && keycode < 127 )
  ) {
    event.preventDefault();
  }
};

const updateFileName = ( nativeFileField, fileNameWrapper )=> {
  if ( nativeFileField.files?.[0] ) {
    fileNameWrapper.html( nativeFileField.files[0].name ).addClass( 'named' );
  } else {
    fileNameWrapper.html( '' ).removeClass( 'named' );
  }
};

export{
  getInputSelector,updateFields,validatePhoneNumberCharacter,validateNameCharacter,updateFileName
};